import * as StringUtils from './string-utils';
import { defineValue } from './object-utils/object-utils';

export const DEFAULT_PERCENTILES = [
  10, 25, 50, 60, 70, 75, 80, 85, 90, 95, 99,
].map((v) => [v, Infinity]);
export const DEFAULT_PERCENTILES_INVERTED = DEFAULT_PERCENTILES.map((p) => [
  p[0],
  -Infinity,
]);

export function getPercentile(value, stats) {
  if (!stats || !stats.percentiles) return '';
  let arr = getPercentilesArray(stats);
  let ret = 0;
  let i = 0;
  while (
    arr[i] &&
    ((stats.inverted && value <= arr[i][1]) ||
      (!stats.inverted && value >= arr[i][1]))
  ) {
    ret = arr[i][0];
    i++;
  }
  if (ret === 0) {
    return '';
  }
  return '' + ret + StringUtils.ordinalSuffix(ret);
}

/**
 * Converts a percentiles map into an array, sorted and mildly cleaned up
 * @param stats
 * @returns {Array}
 */
export function getPercentilesArray(stats) {
  if (!stats || !stats.percentiles) return DEFAULT_PERCENTILES;
  if (!stats.percentilesArray) {
    let percentilesArray = Object.keys(stats.percentiles)
      .map((k) => [+k, +stats.percentiles[k] || 0])
      .sort((a, b) => a[0] - b[0]);
    if (!percentilesArray.length) {
      percentilesArray = stats.inverted
        ? DEFAULT_PERCENTILES_INVERTED
        : DEFAULT_PERCENTILES;
    }
    defineValue(stats, 'percentilesArray', percentilesArray);
  }
  return stats.percentilesArray;
}
